import { SERVER_URLS } from "../../../appConstants";
import { buildUrl } from "../../../ReusableFunctions/reusableFunctions";
import { getToken } from "../../authentication";

export const assignSubscriptionPlan = async (subscriptionData) => {
    try {
            const token = getToken();
            const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/customerSuccessEngineer/subscription/assignSubPlan`,
                {
                    method: "POST",
                    body: JSON.stringify(subscriptionData),
                    headers: {
                        Authorization: `Bearer ${token}`,
                         "Content-Type": "application/json"
                    },
                }
            );
    
            const res = await response.json();
            if (!response.ok) {
                throw (res.message || "Something went wrong while getting subscription details");
            }
            return res?.assignedPlan;       
    } catch (err) {
        throw (err)
    }

}


// export const getSubscriptionDetails = async () => {
//     try{
//           const token = getToken();
//             const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/dsp/subscription`,
//                 {
//                     method: "GET",
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );
    
//              const res = await response.json();
//              console.log('resss444',res)
//             if (!response.ok) {
//                 throw (res.message || "Something went wrong while fetching subscription details");
//             }
//             return res?.subscription
//     } catch(err){
//         throw (err)
//     }
// }


export const getSubscriptionPlansAPI = ({ pageNumber, pageSize, searchQuery, type }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const token = getToken();

            const url = buildUrl(
                SERVER_URLS.BACKEND_SERVER + "/bhumeet_team/customerSuccessEngineer/subscription/plans",
                {
                    pageNumber: pageNumber ? pageNumber : undefined,
                    pageSize: pageSize ? pageSize : undefined,
                    searchQuery: searchQuery || undefined,
                    type: type ? type : undefined
                }
            );

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await response.json();
            if (response.ok) {
                resolve(data?.subPlans);
            } else {
                reject(data?.message || "Something went wrong while fetching subscription plans.");
            }

        } catch (error) {
            reject("Something went wrong while fetching subscription plans.");
        }
    });
};


